var oauthSettings = {
  client_id : "849a22a8-8b1a-4255-8b2f-8cf8fc19b417",
  scope : "https://graph.microsoft.com/User.Read",
  authorize_url : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/authorize",
  token_url : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/token",
  logout_url : "https://login.microsoftonline.com/fbe62081-06d8-481d-baa0-34149cfefa5f/oauth2/v2.0/logout?post_logout_redirect_uri=https://localhost:8080/",
  redirect_uri : window.location.origin,//Gets the current 
  autologin : false,
  debug : true,
};



/*

An OAUTH Wrapper Sample

    <oauth-wrapper 
        :credentials.sync="credentials"
        :authorizeUrl="authorize_url" 
        :tokenUrl="token_url" 
        :logoutUrl="logout_url" 
        :scope="scope" 
        :client_id="client_id" 
        :redirect_uri="redirect_uri" 
        :loginIncrementor="loginIncrementor"
        :autologin="autologin" :debug="debug">

            <!--- Your Protected Content Here --> 

    </oauth-wrapper>


A Login Button Sample (When autologin is FALSE)

    <v-btn @click="login" color="primary">Start Login Process</v-btn>

*/


/*----------------------------- Be careful below this line -------------------------------*/

import oauthWrapper from "@/_components/security/oauth/oauth-wrapper.vue";
import credentials from "@/_mixins/credentials-mixin"


export default {
    components : {oauthWrapper},
    mixins : [credentials],
    data()
    {
        return Object.assign({ loginIncrementor : 0,}, oauthSettings);
    },
    computed : {
        credentials : {
            get(){
              if(this.credentialCacheUID > 0)
              {
                return this.credentialCache[this.client_id];
              }
              return null;
            },
            set(newVal){
              if(!!newVal)
              {
                this.addCredentials(this.client_id, newVal);
              }
            }
          },
    },
    methods : {
        login()
        {
            this.deleteCredentials(this.client_id);
            this.credentials = null;
            this.$nextTick(e => {this.loginIncrementor ++;})//forces the login event on the child component
        },
    }

}
